/**
 * Form Engine Portal host for `@hsus-dev/session-policy` SessionWarningModal.
 *
 * Wires logout + session teardown (`continueSession`, `endSession`).
 * Maps FEP design tokens via `fep-session-warning-bridge` (see sessionExpiredPortalBridge.css).
 */
import React from 'react';
import { SessionWarningModal as HsusSessionWarningModal } from '@hsus-dev/session-policy';
import { continueSession, endSession } from '../../services/session.service';
import { useAuth } from '../../context/AuthContext';

export const SessionWarningModal: React.FC = () => {
  const { logout, isLoggingOut } = useAuth();

  return (
    <div className="fep-session-warning-bridge">
      <HsusSessionWarningModal
        onContinueSession={continueSession}
        isSigningOut={isLoggingOut}
        onSignOut={async () => {
          await logout({ terminateIdpSession: true });
          endSession();
        }}
      />
    </div>
  );
};
